export const PoemDomestic = () => {
    return (
        <div id="051" className="Basic-Text-Frame">
            <p>white yellow sky, good karma,</p>
            <p>a gradient of opportunities,</p>
            <p>i eventually bought this apartment on the sixth floor,</p>
            <p>
                the neighbors upstairs are noisy &amp; the light in the elevator
                goes out every other month,
            </p>
            <p>but you can see the sun setting from up here,</p>
            <p>yes, it could definitely have been</p>
            <p>worse / better, no such thing as fair trades,</p>
            <p>truthfully, if something does want to crawl up to you</p>
            <p>it will inevitably find a way to do so.</p>
            <p>small world,</p>
            <p>shrinking universe,</p>
            <p>as far as i know time stops for no one,</p>
            <p>the proverbial path on the ground demands to be followed,</p>
            <p>the dirt starts moving if you refuse to take a step,</p>
            <p>question is where can this realistically go?</p>
            <p>naturally, some of the other routes close off,</p>
            <p>i don't</p>
            <p>want to find my face somewhere on someone else's body -</p>
            <p>or my body with someone else's head,</p>
            <p>where's the switch that made everything</p>
            <p>too close for comfort?</p>
            <p>the sun reminds you to put on sunscreen.</p>
            <p>conversations about home appliances keep popping up</p>
            <p>far too often.</p>
            <br />
            <p>the present circles around like a fish in a bucket,</p>
            <p>i twirl in my little domestic samsara,</p>
            <p>there's nothing i dislike, i just</p>
            <p>miss the delicious lie that anything could happen.</p>
            <p>i only have my teeth to stab it with.</p>
        </div>
    );
};
